import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

export default function ChannelTabs({ tabs, activeTab, onSelect }) {
  if (!Array.isArray(tabs) || tabs.length === 0) {
    return null;
  }

  return (
    <nav className="channel-tabs" aria-label="Channel applications" role="tablist">
      {tabs.map((tab) => {
        const tabId = tab.id ?? tab.label;
        const isActive = tabId === activeTab;
        return (
        <button
          key={tabId}
          type="button"
          className={`channel-tabs__item ${isActive ? "is-active" : ""}`}
          role="tab"
          aria-selected={isActive}
          tabIndex={isActive ? 0 : -1}
          onClick={() => onSelect?.(tabId)}
        >
          {tab.label}
        </button>
        );
      })}
    </nav>
  );
}

ChannelTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
};

ChannelTabs.defaultProps = {
  tabs: [],
  activeTab: undefined,
  onSelect: undefined,
};
